import React, { useState, useEffect } from 'react'
import { getFirestore, collection, getDocs } from "@firebase/firestore"
import { app } from '../../firebase.js'
import {
  PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer
} from 'recharts'
import Table from 'react-bootstrap/Table'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'

function CampusType() {
  const [chartData, setChartData] = useState([])
  const [tableData, setTableData] = useState([])
  const db = getFirestore(app)

  useEffect(() => {
    const fetchData = async () => {
      const snapshot = await getDocs(collection(db, "users"))
      const typeCounts = {}
      const convertedStatuses = ['Student', 'Completed', 'Deferred', 'Expelled', 'Dropped']
      const notConvertedStatuses = ['inactive', 'Did Not Join']

      snapshot.forEach(doc => {
        const data = doc.data()
        if (data.classType) {
          const type = data.classType

          // Initialize if not exists
          if (!typeCounts[type]) {
            typeCounts[type] = { converted: 0, notConverted: 0 }
          }

          const status = data.userStatus || 'inactive'
          if (convertedStatuses.includes(status)) {
            typeCounts[type].converted += 1
          } else if (notConvertedStatuses.includes(status)) {
            typeCounts[type].notConverted += 1
          }
        }
      })

      // Prepare chart data (total per campus)
      const formattedChartData = Object.keys(typeCounts).map(key => ({
        name: key,
        value: typeCounts[key].converted + typeCounts[key].notConverted
      }))

      // Prepare table data
      const formattedTableData = Object.keys(typeCounts).map(key => ({
        campusType: key,
        converted: typeCounts[key].converted,
        notConverted: typeCounts[key].notConverted
      }))

      setChartData(formattedChartData)
      setTableData(formattedTableData)
    }

    fetchData()
  }, [db])

  const COLORS = ['#4F46E5', '#10B981', '#F59E0B', '#EF4444', '#3B82F6']

  return (
    <div className="d-flex">
      <LeftBar />
      <div className="flex-grow-1">
        <Dashnav />
        <div className="clientsComp p-4">
          <h2 className="mb-4">Campus Type Distribution</h2>

          {/* Chart */}
          <ResponsiveContainer width="100%" height={400}>
            <PieChart>
              <Pie
                data={chartData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={150}
                label
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>

          {/* Table */}
          <h3 className="mt-5 mb-3">Campus Summary</h3>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Campus Type</th>
                <th>Converted</th>
                <th>Not Converted</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  <td>{row.campusType}</td>
                  <td>{row.converted}</td>
                  <td>{row.notConverted}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  )
}

export default CampusType